import React, { FunctionComponent } from "react";
import { NTBCNavigation } from "./NTBCNavigation";
import gears2 from "../assets/lottie/19748-gear-animation.json";
import Lottie from "lottie-react";

export const NTBCHero: FunctionComponent<{}> = (props) => {
  return (
    <div>
      <div className="relative bg-green-50 overflow-hidden">
        <div className="relative pt-6 px-4 sm:px-6 lg:px-8 z-10">
          <NTBCNavigation />
        </div>
        <main className="text-center mt-8 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-8 lg:px-8 xl:mt-10">
          <div className="sm:text-center lg:text-left">
            <p className="pb-6 text-gray-500">
              National Technology and Business Center
            </p>
            <h2 className="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl ">
              Submit your&nbsp;
              <span className="text-green-600">Innovation</span>
            </h2>
            <p
              className="mt-3 text-gray-800 sm:mt-5  sm:max-w-xl sm:mx-auto md:mt-5  lg:mx-0 mb-4"
              style={{ lineHeight: 1.5 }}
            >
              Bring your creative project to life. Simply fill in your project
              details. You can track progress from the NTBC Mobile Application.
            </p>
          </div>
        </main>
        <div className="absolute top-0 inset-x-0 sm:left-8 sm:w-1/2 opacity-25">
          <Lottie animationData={gears2} />
        </div>
      </div>
      <div className="mx-auto max-w-screen-xl px-8 lg:px-32 mt-8 mb-8">
        {props.children}
      </div>
    </div>
  );
};
